// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1SiS9","footer":"ModalFilter_footer__2JADK"};